<template lang="pug">
  v-dialog(v-model='dialog' persistent max-width='600px')
    v-card(grid-list-md)
      v-toolbar(dark, color='primary')
        v-btn(icon, dark, @click='close()')
          v-icon close
        v-toolbar-title {{ $t('pageHeader.editReconcile') }}
      v-card-text(v-if="reconcile")
        v-container(grid-list-lg)
          v-layout(row wrap)
            v-flex(xs12)
              v-layout(row wrap) 
                v-flex(xs12 sm4)
                  v-select(
                    :items="comboBoxByID(24).ComboBoxDetails"
                    :label="$t('labels.duration')"
                    item-text="selector"
                    item-value="id" 
                    v-model="reconcile.chargeDurationID")
                v-flex(xs12 sm3)
                  v-text-field.right-input(prefix="$" :error-messages="feeErrors" v-model="reconcile.softwareFee" label='Fee')
                v-flex(xs12 sm5)
                  v-autocomplete(v-model="reconcile.assignedUserID"
                    :items="users"
                    item-text='fullName'
                    item-value="userID"
                    :label="$t('labels.assignedUser')")
                v-flex(xs12)
                  v-divider
                
                v-flex(xs12 sm6)
                  v-text-field(v-model="reconcile.teamViewerID" label='Teamviewer ID') 
                v-flex(xs12 sm6)
                  v-text-field(v-model="reconcile.accessCode" label='Access Code')
                v-flex(xs12 sm6)
                  v-text-field(v-model="reconcile.userName" label='User Name')
                v-flex(xs12 sm6)
                  v-text-field(v-model="reconcile.password" label='Password')  
                v-flex(xs12)
                  v-text-field(v-model="reconcile.folderLink" label='Folder Link')  

      v-card-actions
        v-spacer
        v-btn(color='blue darken-1', flat, @click='close()') Close
        v-btn(color='blue darken-1' dark @click='update()') Update
      
</template>

<script>
import { mapGetters } from "vuex";
import ReconcileService from "../service.js";
import DateTimePicker from "../../../Global/components/DateTimePicker";
import userService from "../../../User/service.js";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    reconcile: {
      default: {}
    },
    editDialog: {
      default: false
    }
  },
  name: "update-reconcile",
  data() {
    return {
      dialog: false,
      stores: [],
      users: []
    };
  },
  mixins: [validationMixin],
  validations: {
    reconcile: {
      softwareFee: {
        required
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBox", "comboBoxByID", "currentUser"]),
    ...mapGetters("location", ["location"]),
    feeErrors() {
      const errors = [];
      if (!this.$v.reconcile.softwareFee.$dirty) return errors;
      if (!this.$v.reconcile.softwareFee.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  },
  components: {
    DateTimePicker
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
      if (val) {
        this.getAllUsers();
        // this.reconcile.assignedToUserID = this.currentUser.userID
        // this.reconcile.createdUserID = this.currentUser.userID
        // this.reconcile.storeID = this.location.storeID
      }
    }
  },
  methods: {
    setDueDate(val) {
      this.reconcile.dueDate = val;
    },
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.users = result.data;
      });
    },
    close() {
      this.$emit("close");
    },
    update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        ReconcileService.update(this.reconcile.storeID, 193, this.reconcile)
          .then(result => {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            });

            Toast.fire({
              type: "success",
              title: "Reconcile Service is started"
            });
            this.$emit("updated");
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>

<style>
.v-expansion-panel__header {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
